import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Dimensions,
  Platform,
  Image,
} from 'react-native';
import Header from '../components/Header';
import Footer from '../components/Footer';

const { width } = Dimensions.get('window');

const HomeScreen = ({ navigation }) => {
  // All available calculators
  const allCalculators = [
    {
      id: 'sip',
      title: 'SIP',
      description: 'Calculate how much you need to invest each month to reach your financial goals',
      icon: require('../../assets/icons/finance.png'),
      color: '#4F46E5',
      screen: 'SIPCalculator',
      slug: 'sip-calculator'
    },
    {
      id: 'flat-vs-reducing',
      title: 'Flat vs Reducing Rate',
      description: 'Compare EMIs and total interest across methods',
      icon: require('../../assets/icons/money.png'),
      color: '#F59E0B',
      screen: 'FlatVsReducingRateCalculator',
      slug: 'flat-vs-reducing-rate-calculator'
    },
    {
      id: 'brokerage',
      title: 'Brokerage',
      description: 'Estimate trading charges and net PnL',
      icon: require('../../assets/icons/money.png'),
      color: '#3B82F6',
      screen: 'BrokerageCalculator',
      slug: 'brokerage-calculator'
    },
    {
      id: 'cagr',
      title: 'CAGR',
      description: 'Compute compound annual growth rate between two values',
      icon: require('../../assets/icons/finance.png'),
      color: '#10B981',
      screen: 'CAGRCalculator',
      slug: 'cagr-calculator'
    },
    {
      id: 'step-up-sip',
      title: 'Step-Up SIP',
      description: 'Build corpus with annual increase in SIP amount',
      icon: require('../../assets/icons/earnings.png'),
      color: '#16A34A',
      screen: 'StepUpSIPCalculator',
      slug: 'step-up-sip-calculator'
    },
    {
      id: 'lumpsum',
      title: 'Lumpsum',
      description: 'Calculate returns on lumpsum investments and plan your financial future',
      icon: require('../../assets/icons/money.png'),
      color: '#059669',
      screen: 'LumpsumCalculator',
      slug: 'lumpsum-calculator'
    },
    {
      id: 'retirement',
      title: 'Retirement',
      description: 'Estimate corpus, annuity purchase and monthly pension',
      icon: require('../../assets/icons/finance.png'),
      color: '#0EA5E9',
      screen: 'RetirementCalculator',
      slug: 'retirement-calculator'
    },
    {
      id: 'swp',
      title: 'SWP',
      description: 'Calculate your final amount after Systematic Withdrawal Plan',
      icon: require('../../assets/icons/earnings.png'),
      color: '#DC2626',
      screen: 'SWPCalculator',
      slug: 'swp-calculator'
    },
    {
      id: 'mf',
      title: 'MF',
      description: 'Calculate the returns on your Mutual Fund investments',
      icon: require('../../assets/icons/finance.png'),
      color: '#7C3AED',
      screen: 'MutualFundReturnsCalculator',
      slug: 'mutual-fund-calculator'
    },
    {
      id: 'compound-interest',
      title: 'Compound Interest',
      description: 'Project growth with compounding at chosen frequency',
      icon: require('../../assets/icons/money.png'),
      color: '#1E40AF',
      screen: 'CompoundInterestCalculator',
      slug: 'compound-interest-calculator'
    },
    {
      id: 'apy',
      title: 'APY',
      description: 'Convert APR to APY and project effective yield',
      icon: require('../../assets/icons/finance.png'),
      color: '#1D4ED8',
      screen: 'APYCalculator',
      slug: 'apy-calculator'
    },
    {
      id: 'ppf',
      title: 'PPF',
      description: 'Calculate your returns on Public Provident Fund (PPF)',
      icon: require('../../assets/icons/money.png'),
      color: '#0891B2',
      screen: 'PPFCalculator',
      slug: 'ppf-calculator'
    },
    {
      id: 'ssy',
      title: 'SSY',
      description: 'Calculate returns for Sukanya Samriddhi Yojana (SSY)',
      icon: require('../../assets/icons/finance.png'),
      color: '#2563EB',
      screen: 'SSYCalculator',
      slug: 'ssy-calculator'
    },
    {
      id: 'epf',
      title: 'EPF',
      description: 'Calculate returns for your Employees Provident Fund',
      icon: require('../../assets/icons/earnings.png'),
      color: '#EA580C',
      screen: 'PFCalculator',
      slug: 'epf-calculator'
    },
    {
      id: 'nps',
      title: 'NPS',
      description: 'Estimate corpus and pension for National Pension System',
      icon: require('../../assets/icons/money.png'),
      color: '#0EA5E9',
      screen: 'NPSCalculator',
      slug: 'nps-calculator'
    },
    {
      id: 'nsc',
      title: 'NSC',
      description: 'Calculate maturity value for National Savings Certificate',
      icon: require('../../assets/icons/finance.png'),
      color: '#2563EB',
      screen: 'NSCCalculator',
      slug: 'nsc-calculator'
    },
    {
      id: 'fd',
      title: 'FD',
      description: 'Check returns on your Fixed Deposit (FD) without any hassle',
      icon: require('../../assets/icons/finance.png'),
      color: '#16A34A',
      screen: 'FDCalculator',
      slug: 'fd-calculator'
    },
    {
      id: 'emi',
      title: 'EMI',
      description: 'Calculate EMI for your loan and plan your finances',
      icon: require('../../assets/icons/money.png'),
      color: '#DB2777',
      screen: 'EMICalculator',
      slug: 'emi-calculator'
    },
    {
      id: 'income-tax',
      title: 'Income Tax',
      description: 'Calculate your income tax with performance and AIS',
      icon: require('../../assets/icons/tax.png'),
      color: '#9333EA',
      screen: 'IncomeTaxCalculator',
      slug: 'income-tax-calculator'
    },
    {
      id: 'home-loan-emi',
      title: 'Home Loan EMI',
      description: 'Calculate EMI for your home loan with detailed breakdown',
      icon: require('../../assets/icons/home-loan.png'),
      color: '#0D9488',
      screen: 'HomeLoanEMICalculator',
      slug: 'home-loan-emi-calculator'
    },
    {
      id: 'car-loan-emi',
      title: 'Car Loan EMI',
      description: 'Calculate EMI for your car loan and plan your budget',
      icon: require('../../assets/icons/car-loan.png'),
      color: '#DC2626',
      screen: 'CarLoanEMICalculator',
      slug: 'car-loan-emi-calculator'
    },
    {
      id: 'personal-loan-emi',
      title: 'Personal Loan EMI',
      description: 'Calculate EMI for your personal loan requirements',
      icon: require('../../assets/icons/personal loan.png'),
      color: '#7C2D12',
      screen: 'PersonalLoanEMICalculator',
      slug: 'personal-loan-emi-calculator'
    },
    {
      id: 'business-loan-emi',
      title: 'Business Loan EMI',
      description: 'Calculate EMI for your business loan and expansion plans',
      icon: require('../../assets/icons/business-loan.png'),
      color: '#1E40AF',
      screen: 'BusinessLoanEMICalculator',
      slug: 'business-loan-emi-calculator'
    },
    {
      id: 'rd',
      title: 'RD',
      description: 'Calculate returns on your Recurring Deposit (RD)',
      icon: require('../../assets/icons/finance.png'),
      color: '#059669',
      screen: 'RDCalculator',
      slug: 'rd-calculator'
    },
    {
      id: 'hra',
      title: 'HRA',
      description: 'Calculate your House Rent Allowance (HRA) exemption',
      icon: require('../../assets/icons/earnings.png'),
      color: '#7C3AED',
      screen: 'HRACalculator',
      slug: 'hra-calculator'
    },
    {
      id: 'gst',
      title: 'GST',
      description: 'Calculate GST amount for your business transactions',
      icon: require('../../assets/icons/tax.png'),
      color: '#DC2626',
      screen: 'GSTCalculator',
      slug: 'gst-calculator'
    },
    {
      id: 'tds',
      title: 'TDS',
      description: 'Calculate Tax Deducted at Source (TDS) for various incomes',
      icon: require('../../assets/icons/tax.png'),
      color: '#9333EA',
      screen: 'TDSCalculator',
      slug: 'tds-calculator'
    },
    {
      id: 'advance-tax',
      title: 'Advance Tax',
      description: 'Calculate advance tax liability for the financial year',
      icon: require('../../assets/icons/tax.png'),
      color: '#0891B2',
      screen: 'AdvanceTaxCalculator',
      slug: 'advance-tax-calculator'
    },
    {
      id: 'capital-gains',
      title: 'Capital Gains',
      description: 'Calculate capital gains tax on your investments',
      icon: require('../../assets/icons/earnings.png'),
      color: '#EA580C',
      screen: 'CapitalGainsCalculator',
      slug: 'capital-gains-calculator'
    },
    {
      id: 'salary',
      title: 'Salary',
      description: 'Calculate your take-home salary after deductions',
      icon: require('../../assets/icons/money.png'),
      color: '#16A34A',
      screen: 'SalaryCalculator',
      slug: 'salary-calculator'
    },
    {
      id: 'gratuity',
      title: 'Gratuity',
      description: 'Calculate gratuity amount based on your service period',
      icon: require('../../assets/icons/earnings.png'),
      color: '#DB2777',
      screen: 'GratuityCalculator',
      slug: 'gratuity-calculator'
    },
    {
      id: 'simple-interest',
      title: 'Simple Interest',
      description: 'Calculate simple interest on your investments',
      icon: require('../../assets/icons/finance.png'),
      color: '#0D9488',
      screen: 'SimpleInterestCalculator',
      slug: 'simple-interest-calculator'
    },
    {
      id: 'down-payment',
      title: 'Down Payment',
      description: 'Calculate down payment required for your loan',
      icon: require('../../assets/icons/money.png'),
      color: '#7C2D12',
      screen: 'DownPaymentCalculator',
      slug: 'down-payment-calculator'
    }
  ];

  // Additional calculators
  const newCalculators = [
    {
      id: 'margin',
      title: 'Margin',
      description: 'Estimate required margin and exposure for trades',
      icon: require('../../assets/icons/finance.png'),
      color: '#0EA5E9',
      screen: 'MarginCalculator',
      slug: 'margin-calculator'
    },
    {
      id: 'inflation',
      title: 'Inflation',
      description: 'See inflation impact and real return over time',
      icon: require('../../assets/icons/money.png'),
      color: '#F59E0B',
      screen: 'InflationCalculator',
      slug: 'inflation-calculator'
    },
    {
      id: 'post-office-mis',
      title: 'Post Office MIS',
      description: 'Compute monthly income and maturity for PO MIS',
      icon: require('../../assets/icons/finance.png'),
      color: '#16A34A',
      screen: 'PostOfficeMISCalculator',
      slug: 'post-office-mis-calculator'
    },
    {
      id: 'scss',
      title: 'SCSS',
      description: 'Calculate Senior Citizens Savings Scheme returns',
      icon: require('../../assets/icons/finance.png'),
      color: '#2563EB',
      screen: 'SCSSCalculator',
      slug: 'scss-calculator'
    },
    {
      id: 'stock-average',
      title: 'Stock Average',
      description: 'Compute average price across multiple purchase lots',
      icon: require('../../assets/icons/money.png'),
      color: '#10B981',
      screen: 'StockAverageCalculator',
      slug: 'stock-average-calculator'
    },
    {
      id: 'xirr',
      title: 'XIRR',
      description: 'Calculate annualized returns for irregular cashflows',
      icon: require('../../assets/icons/finance.png'),
      color: '#4F46E5',
      screen: 'XIRRCalculator',
      slug: 'xirr-calculator'
    }
  ];

  const navigateToCalculator = (calculator) => {
    // Navigate with the new URL structure
    navigation.navigate(calculator.screen, { 
      calculatorSlug: calculator.slug 
    });
  };

  const renderCalculatorCard = (calculator) => (
    <TouchableOpacity
      key={calculator.id}
      style={[styles.calculatorCard, { backgroundColor: calculator.color + '15' }]}
      onPress={() => navigateToCalculator(calculator)}
      activeOpacity={0.8}
    >
      <View style={[styles.cardIconContainer, { backgroundColor: calculator.color + '25' }]}>
        <Image 
          source={calculator.icon} 
          style={styles.cardIcon}
          resizeMode="contain"
        />
      </View>
      <Text style={styles.cardTitle}>{calculator.title}</Text>
      <Text style={styles.cardDescription}>{calculator.description}</Text>
    </TouchableOpacity>
  );

  return (
    <View style={styles.container}>
      <Header />
      <ScrollView style={styles.scrollView} showsVerticalScrollIndicator={false}>
        {/* Hero Section */}
        <View style={styles.heroSection}>
          <Text style={styles.heroTitle}>Financial Calculators</Text>
          <Text style={styles.heroSubtitle}>Your Complete Financial Calculator Suite</Text>
          <Text style={styles.heroDescription}>
            Calculate taxes, EMIs, SIPs and more with our comprehensive set of financial tools
          </Text>
        </View>

        {/* Calculator Tools Section */}
        <View style={styles.calculatorSection}>
          <View style={styles.calculatorGrid}>
            {[...allCalculators, ...newCalculators].map((calculator) => renderCalculatorCard(calculator))}
          </View>
        </View>
      </ScrollView>
      <Footer />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f8fafc',
  },
  scrollView: {
    flex: 1,
  },
  heroSection: {
    backgroundColor: '#4f46e5',
    paddingVertical: 60,
    paddingHorizontal: 20,
    alignItems: 'center',
    marginBottom: 40,
  },
  heroTitle: {
    fontSize: width > 768 ? 48 : width > 480 ? 36 : 28,
    fontWeight: 'bold',
    color: 'white',
    textAlign: 'center',
    marginBottom: 10,
  },
  heroSubtitle: {
    fontSize: width > 768 ? 20 : width > 480 ? 18 : 16,
    color: '#e0e7ff',
    textAlign: 'center',
    marginBottom: 15,
  },
  heroDescription: {
    fontSize: 16,
    color: '#c7d2fe',
    textAlign: 'center',
    maxWidth: 600,
    lineHeight: 24,
  },
  calculatorSection: {
    paddingHorizontal: 20,
    marginBottom: 60,
  },
  sectionTitle: {
    fontSize: 32,
    fontWeight: 'bold',
    color: '#1e293b',
    textAlign: 'center',
    marginBottom: 8,
  },
  sectionSubtitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#4b5563',
    textAlign: 'center',
    marginBottom: 8,
  },
  sectionDescription: {
    fontSize: 16,
    color: '#6b7280',
    textAlign: 'center',
    marginBottom: 32,
    lineHeight: 24,
  },
  calculatorGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    paddingHorizontal: 10,
    maxWidth: 1200,
    alignSelf: 'center',
  },
  calculatorCard: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 16,
    width: width > 1024 ? '23%' : width > 768 ? '30%' : width > 480 ? '45%' : '90%',
    minWidth: width > 768 ? 250 : width > 480 ? 160 : 280,
    minHeight: 160,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 12,
    elevation: 6,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
    borderWidth: 1,
    borderColor: '#f1f5f9',
  },
  cardIconContainer: {
    width: 64,
    height: 64,
    borderRadius: 32,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
  },
  cardIcon: {
    width: 32,
    height: 32,
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1f2937',
    textAlign: 'center',
    marginBottom: 8,
  },
  cardDescription: {
    fontSize: 13,
    color: '#6b7280',
    textAlign: 'center',
    lineHeight: 18,
    paddingHorizontal: 8,
  },
  featuresSection: {
    paddingHorizontal: 20,
    paddingVertical: 60,
    backgroundColor: '#f8fafc',
  },
  featuresGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 30,
    maxWidth: 1000,
    alignSelf: 'center',
  },
  featureCard: {
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 30,
    width: width > 800 ? 220 : width > 600 ? 180 : (width - 80) / 2,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 10,
    elevation: 2,
  },
  featureIcon: {
    fontSize: 40,
    marginBottom: 15,
  },
  featureTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1e293b',
    textAlign: 'center',
    marginBottom: 10,
  },
  featureDescription: {
    fontSize: 14,
    color: '#64748b',
    textAlign: 'center',
    lineHeight: 20,
  },
});

export default HomeScreen;